





























































































import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import {
  Action,
  Getter,
} from 'vuex-class';
import ImageSelector from '@/components/ImageSelector.vue';

@Component({
  components: {ImageSelector},
})
export default class DlgAnimalsEdit extends Vue {
  public $refs!: {
    form: any,
  };

  @Prop({type: Object, default: null}) private animal!: any;
  @Action('admin/animals/update') private updateAnimal!: any;
  @Action('admin/animals/read') private readAnimals!: any;
  @Action('admin/animals/uploadImage') private uploadImage!: any;
  @Getter('common/rules/all') private rules!: any;

  private localAnimal: any = null;
  private dialog: boolean = false;
  private loading: boolean = false;
  private valid: boolean = true;
  private profileImage: any = null;

  @Watch('dialog')
  private onDialogChanged(val: boolean) {
    if (val) {
      this.localAnimal = JSON.parse(JSON.stringify(this.animal));
    }
  }

  private async update() {
    if (this.$refs.form.validate()) {
      this.loading = true;

      if (this.profileImage) {
        this.localAnimal.profileImage = await this.uploadImage(this.profileImage);
      }

      this.updateAnimal(this.localAnimal)
        .then((success: any) => {
          if (success) {
            return this.readAnimals();
          }
          this.loading = false;
        })
        .then(() => {
          this.loading = false;
          this.dialog = false;
          this.localAnimal = null;
          this.$refs.form.resetValidation();
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
}
